import React from 'react';
import { block } from '../utils/cn';
import { Popover } from '../Popover';
import { Icon } from '../Icon';
import { QuestionMarkIcon } from '../icons/QuestionMarkIcon';
import './HelpPopover.css';
const b = block('help-popover');
export function HelpPopover(props) {
    return (React.createElement(Popover, Object.assign({ offset: { left: 4 } }, props, { className: b(null, props.className) }),
        React.createElement(Icon, { data: QuestionMarkIcon, size: 16 })));
}
